import Box from "@mui/material/Box";
import MuiModal from "@mui/material/Modal";
import { Animated, View } from "react-native";
import ModalHeader from "./ModalHeader";
import { Props } from "./types";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%",
    sm: 480,
  },
  maxHeight: "90vh",
  bgcolor: "white",
  borderRadius: "16px",
  overflowY: "auto",
  overflowX: "hidden",
  outline: "none",
  display: "flex",
  flexDirection: "column",
};

export default function Modal({
  visible,
  onDismiss,
  webStyle,
  children,
  title,
  hasBorder = !!title,
  flatListProps,
  FooterComponent,
  HeaderComponent,
}: Props) {
  return (
    <MuiModal open={visible} onClose={onDismiss}>
      <Box sx={[style, webStyle || {}]}>
        {HeaderComponent || <ModalHeader {...{ title, hasBorder, onDismiss }} />}
        {children}
        {flatListProps && <Animated.FlatList {...flatListProps} />}
        {FooterComponent && <View className="justify-self-end">{FooterComponent}</View>}
      </Box>
    </MuiModal>
  );
}
